import { any, bool, func, string } from 'prop-types'
import { AnalyticsConsumer, AnalyticsLayer } from '@opallabs/quanta'
import { kuiperClassNames, noPropagate } from '../../../utils'

import './styles.scss'

function changer(onChange, value, disabled, track) {
  if (disabled) {
    return null
  }

  return noPropagate(() => onChange(value, track))
}

const RadioOption = ({ disabled, label, onChange, selectedValue, value }) => {
  const selected = value === selectedValue
  return (
    <AnalyticsLayer name={label}>
      <AnalyticsConsumer>
        {({ track }) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            onClick={changer(onChange, value, disabled, track)}
            className={kuiperClassNames('radio-option', { selected, disabled })}
          >
            <label>{label}</label>
          </div>
        )}
      </AnalyticsConsumer>
    </AnalyticsLayer>
  )
}

RadioOption.propTypes = {
  disabled: bool,
  label: string,
  onChange: func,
  selectedValue: any,
  value: any,
}

export default RadioOption
